import { useEffect, useState } from 'react'
import { WalletCardAsset } from './types'

/**
 * Resolves a wallet asset to a renderable URL. A File (picked in the
 * uploader, not yet submitted) gets a local object URL so the admin sees
 * their upload immediately; the URL is revoked whenever the asset changes or
 * the component unmounts so previews never leak memory.
 */
export const useWalletAssetUrl = (
  asset: WalletCardAsset
): string | undefined => {
  const [objectUrl, setObjectUrl] = useState<string>()

  useEffect(() => {
    if (!(asset instanceof File)) {
      setObjectUrl(undefined)
      return
    }

    const url = URL.createObjectURL(asset)
    setObjectUrl(url)

    return () => URL.revokeObjectURL(url)
  }, [asset])

  if (typeof asset === 'string') {
    return asset
  }

  return objectUrl
}
